import { WeekDayInitials } from "../../../../../util/enums";

export type WeekDayOption = {
  label: WeekDayInitials;
  value: number;
};

export const WeekOptions: WeekDayOption[] = [
  {
    label: WeekDayInitials.SUNDAY,
    value: 0,
  },
  {
    label: WeekDayInitials.MONDAY,
    value: 1,
  },
  {
    label: WeekDayInitials.TUESDAY,
    value: 2,
  },
  {
    label: WeekDayInitials.WEDNESDAY,
    value: 3,
  },
  {
    label: WeekDayInitials.THURSDAY,
    value: 4,
  },
  {
    label: WeekDayInitials.FRIDAY,
    value: 5,
  },
  {
    label: WeekDayInitials.SATURDAY,
    value: 6,
  },
];

export const MD_SIZE_CARD = 6;
export const SM_SIZE_CARD = 6;
export const XS_SIZE_CARD = 12;

export const WEEK_SPLITTER = ",";
